var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#F7F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.05V8H23V10.05C25.4666 10.2979 27.7533 11.4532 29.4162 13.2917C31.0792 15.1302 32 17.5209 32 20V30H34V32H26.196C26.1488 33.0812 25.6861 34.1024 24.9043 34.8507C24.1226 35.599 23.0822 36.0167 22 36.0167C20.9178 36.0167 19.8774 35.599 19.0957 34.8507C18.3139 34.1024 17.8512 33.0812 17.804 32H10V30H12V20C12 17.5209 12.9208 15.1302 14.5838 13.2917C16.2467 11.4532 18.5334 10.2979 21 10.05ZM19.808 32C19.8549 32.549 20.1062 33.0604 20.5121 33.4331C20.918 33.8058 21.449 34.0126 22 34.0126C22.551 34.0126 23.082 33.8058 23.4879 33.4331C23.8938 33.0604 24.1451 32.549 24.192 32H19.808Z",
    fill: "#7692FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5a88be9bf930267a362e6a02728c1ee9.svg";
export { ForwardRef as ReactComponent };